module.exports = __webpack_public_path__ + "static/bg-0108360fba73be18d9da6c24c828c8c1.png";